import { PLAYER_BANK_ACCOUNTS, PLAYER_CRYPT_WALLETS } from '~/utils/api-response/player'

// State
export const state = () => ({
  loading: false,
  bankAccount: {
    account_holder_name: null
  },
  playerCryptoWallets: []
})

// Actions
export const actions = {
  // Get bank account
  getBankPlayerAccount({ commit }) {
    const response = PLAYER_BANK_ACCOUNTS
    commit('setBankAccount', response.data)
  },
  // Insert bank account
  async doInsertPlayerBankAccount({ commit, dispatch }, form) {},
  // Update bank account
  async doUpdatePlayerBankAccount({ commit, dispatch }, { form, accountId }) {},
  // Delete bank account
  async doDeletePlayerBankAccount({ commit, dispatch }, accountId) {},
  async createPlayerCryptoWallet({ dispatch }, form) {},
  playerCryptoWallet({ commit }, params) {
    const response = PLAYER_CRYPT_WALLETS
    commit('setPlayerCryptoWallets', response.data)
  },
  async deletePlayerCryptoWallet({ dispatch }, id) {},
  async updatePlayerCryptoWallet({ dispatch }, form) {}
}

// Mutations
export const mutations = {
  setLoading: (state, v) => {
    state.loading = v
  },
  setBankAccount: (state, v) => {
    if (v?.player_bank_accounts) {
      v.player_bank_accounts = v.player_bank_accounts.sort((b, a) => a.is_primary - b.is_primary)
    }
    state.bankAccount = v
  },
  setPlayerCryptoWallets: (state, v) => {
    const accounts = v.sort((b, a) => a.is_primary - b.is_primary)
    state.playerCryptoWallets = accounts
  }
}

// Getters
export const getters = {
  bankAccount: state => state.bankAccount,
  loading: state => state.loading,
  primaryBankAccount: state => {
    return state.bankAccount.player_bank_accounts
      ? state.bankAccount.player_bank_accounts.find(o => o.is_primary === true)
      : {}
  }
}
